import type { ListenerEntry } from "@poscon/shared-frontend";
import type { RootDispatch, RootState } from "~redux/store";
import { startListening } from "~redux/listenerMiddleware";
import { dposConfigSelector, mapCenterSelector, viewDimensionSelector, viewIsFullscreenSelector } from "~redux/slices/edstSlice";
import { headerRowHeight } from "~/utils/constants";
import type { GeoProjectionState } from "~/geoProjectionStore";
import { GeoProjectionStore } from "~/geoProjectionStore";
import { gpdCenterOverrideSelector, gpdScaleSelector } from "~redux/slices/gpdSlice";

export type GpdGeoState = GeoProjectionState;

const listeners: ListenerEntry<RootState, RootDispatch>[] = [
  {
    predicate: (action, state, prevState) =>
      dposConfigSelector(state) !== dposConfigSelector(prevState) ||
      mapCenterSelector(state) !== mapCenterSelector(prevState) ||
      gpdScaleSelector(state) !== gpdScaleSelector(prevState) ||
      gpdCenterOverrideSelector(state) !== gpdCenterOverrideSelector(prevState),
    effect: (action, { getState }) => {
      const state = getState();
      let center = mapCenterSelector(state);
      if (center[0] === 0 && center[1] === 0) {
        center = dposConfigSelector(state).gpdParams.gpdCenter;
      }
      const centerOverride = gpdCenterOverrideSelector(state);
      gpdStore.setCenter(center);
      gpdStore.setMatrix(gpdScaleSelector(state), centerOverride[0], centerOverride[1]);
    },
  },
  {
    predicate: (action, state, prevState) =>
      viewDimensionSelector(state, "GPD") !== viewDimensionSelector(prevState, "GPD") ||
      viewIsFullscreenSelector(state, "GPD") !== viewIsFullscreenSelector(prevState, "GPD"),
    effect: (action, { getState }) => {
      const state = getState();
      const isFullscreen = viewIsFullscreenSelector(state, "GPD");
      gpdStore.isFullscreen = isFullscreen;
      if (isFullscreen) {
        gpdStore.setDimensions({
          width: window.innerWidth - 3,
          height: window.innerHeight - headerRowHeight - 6,
        });
      } else {
        gpdStore.setDimensions(viewDimensionSelector(state, "GPD"));
      }
    },
  },
];

listeners.forEach((listener) => startListening(listener));

export const gpdStore = new GeoProjectionStore((dimensions, rect) => [
  Math.floor(dimensions.width / 2),
  Math.floor(rect.height / 2),
]);
